import api from './api';

interface QuickBooksAuthResponse {
  authorizationUrl: string;
}

interface QuickBooksConnectionStatus {
  connected: boolean;
  companyName?: string;
  realmId?: string;
  lastSync?: string;
  error?: string;
}

export const quickbooksApi = {
  // Initiate OAuth connection
  initiateConnection: async (organizationId: string): Promise<QuickBooksAuthResponse> => {
    if (!organizationId) {
      throw new Error('Organization ID is required but not provided.');
    }
    const response = await api.post('/api/integrations/quickbooks/connect', { organizationId });
    return response.data;
  },

  // Check connection status
  getConnectionStatus: async (dataSourceId: string): Promise<QuickBooksConnectionStatus> => {
    const response = await api.get(`/api/integrations/quickbooks/status/${dataSourceId}`);
    return response.data;
  },

  // Disconnect QuickBooks
  disconnect: async (dataSourceId: string): Promise<void> => {
    await api.post(`/api/integrations/quickbooks/disconnect/${dataSourceId}`, {});
  },

  // Trigger manual sync
  syncNow: async (dataSourceId: string): Promise<{ message: string }> => {
    const response = await api.post(`/api/integrations/quickbooks/sync/${dataSourceId}`, {});
    return response.data;
  },
};
